export const langs = [
  {
    title: "English",
    param: "en",
    image: "/images/flags-language/000-english.svg",
  },
  {
    title: "Italiano",
    param: "it",
    image: "/images/flags-language/263-italy.svg",
  },
  {
    title: "French",
    param: "fr",
    image: "/images/flags-language/197-france.svg",
  },
  {
    title: "Espanol",
    param: "es",
    image: "/images/flags-language/230-spain.svg",
  },
  {
    title: "Deutsch",
    param: "de",
    image: "/images/flags-language/208-germany.svg",
  },
  {
    title: "Dutch",
    param: "nl",
    image: "/images/flags-language/077-netherlands.svg",
  },
  {
    title: "Portugese",
    param: "pt",
    image: "/images/flags-language/098-portugal.svg",
  },
  {
    title: "Українська",
    param: "uk",
    image: "/images/flags-language/198-ukraine.svg",
  },
  {
    title: "Русский",
    param: "ru",
    image: "/images/flags-language/044-russia.svg",
  },
];
